import { getBestQuality } from '@anm/hosting-player';

var getBestMedia = function getBestMedia(main, type) {
  var allMedias = main.filter(function (media) {
    return media.type === type;
  });
  var bestMedia = getBestQuality(allMedias);
  return bestMedia || {};
};

export default getBestMedia;